/** Motivos de rechazo de documento ID/cédula (admin → usuario). */
export const ID_DOC_REJECT_REASONS = [
  {
    code: 'reupload_document',
    es: 'Subir documento de nuevo',
    en: 'Please upload the document again',
  },
  {
    code: 'document_type_not_accepted',
    es: 'No se admite este tipo de documento',
    en: 'This type of document is not accepted',
  },
  {
    code: 'requirement_not_met',
    es: 'No cumples con el requisito',
    en: 'You do not meet the requirement',
  },
  {
    code: 'other',
    es: 'Otros',
    en: 'Other',
  },
];

export function idDocRejectReasonLabel(code, locale = 'es', otherText = '') {
  const row = ID_DOC_REJECT_REASONS.find((r) => r.code === code);
  const lang = String(locale || 'es').toLowerCase().startsWith('en') ? 'en' : 'es';
  if (!row) return otherText || (lang === 'en' ? 'Rejected' : 'Rechazado');
  if (code === 'other' && otherText) return otherText;
  return row[lang] || row.es;
}

/**
 * Gate operativo para pedir/aceptar viajes o ponerse en línea.
 * Pasajeros: siempre OK (verificación de cédula es opcional; solo da insignia).
 * Conductores: si imageIdApproval está activo, exigen doc + número y no rechazado.
 */
export function isVerifyIdReady(profile, settings) {
  if (!settings?.imageIdApproval) return true;
  if (profile?.usertype === 'customer') return true;
  if (!profile?.verifyId || !profile?.verifyIdImage) return false;
  if (profile.verifyIdStatus === 'rejected') return false;
  return true;
}

/** Insignia «Verificado»: documento ID aprobado por admin. */
export function isIdVerified(profile) {
  if (!profile) return false;
  if (profile.verifyIdStatus === 'approved') return true;
  return !!(profile.verifyIdApproved && profile.verifyIdStatus !== 'rejected');
}
